'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.getCookie = getCookie;
exports.setCookie = setCookie;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COOKIE_KEY = 'AcastConsent';
var DEFAULT_COOKIE_EXPIRES = 1000 * 60 * 60 * 24 * 365;
var DEFAULT_COOKIE_REGEX = '(?:^|;)\\s?' + DEFAULT_COOKIE_KEY + '=(.*?)(?:;|$)';

function getTopLevelDomain() {
  var parts = window.location.hostname.split('.');
  var last = parts[parts.length - 1];

  var isIPAddress = parts.length === 4 && last == parseInt(last, 10);
  if (isIPAddress) {
    return '';
  }
  var isLocalhost = parts.length <= 1;
  if (isLocalhost) {
    return '';
  }

  return parts.slice(-2).join('.');
}

function getCookieDomain() {
  var domain = getTopLevelDomain();
  if (domain.length) {
    return '.' + domain;
  }

  return undefined;
}

function getCookie() {
  var cookieRegex = new RegExp(DEFAULT_COOKIE_REGEX);

  var _ref = document.cookie.match(cookieRegex) || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      match = _ref2[1];

  try {
    return match ? JSON.parse(match) : undefined;
  } catch (err) {
    return undefined;
  }
}

function setCookie(value) {
  var cookie = [DEFAULT_COOKIE_KEY + '=' + JSON.stringify(value)];
  var domain = getCookieDomain();
  if (domain) {
    cookie.push('domain=' + domain);
  }

  var expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + DEFAULT_COOKIE_EXPIRES);
  cookie.push('expires=' + expiryDate.toUTCString());
  cookie.push('path=/');

  document.cookie = cookie.join('; ');
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-www-uikit/dist/components/cookie-consent/utils.js
// module id = UW4/
// module chunks = 15